export const ASSESSMENT_OUTCOMES = ["Initial Check-Ride Completed"];

export function stageForRun(n) {
  if (n === 1) return "Assessment";
  if (n >= 2 && n <= 10) return "Training";
  if (n === 11) return "Check Ride";
  if (n >= 12 && n <= 14) return "Targeted Training";
  if (n === 15) return "Final Assessment";
  if (n >= 16 && n <= 20) return "Extra Training";
  return "Approved for Test";
}

// Run 11 "Check Ride" is shown as "Associate Check Ride" in the UI, while the
// internal stage key stays "Check Ride" for gating/progression. Run 15
// "Final Assessment" is shown as "Test Check-Ride".
export function stageLabel(stage) {
  if (stage === "Check Ride") return "Test Check Ride";
  if (stage === "Final Assessment") return "Test Check Ride";
  return stage ?? "";
}

export function canRecordStage(role, stage, isAssessorTrainer) {
  if (role === "Admin") return true;
  if (role === "HOT") return stage === "Extra Training";
  if (role === "Assessor") {
    // Dedicated Assessors handle the Test Check Rides (Runs 11 & 15) only.
    return stage === "Check Ride" || stage === "Final Assessment";
  }
  if (role === "Tutor") {
    if (stage === "Assessment" || stage === "Training" || stage === "Targeted Training" || stage === "Extra Training") return true;
    // Test Check Rides (Runs 11 & 15) are for Assessors only — a plain Tutor
    // cannot record them unless they also hold the "Also an Assessor" tick.
    if (stage === "Check Ride" || stage === "Final Assessment") return !!isAssessorTrainer;
    return false;
  }
  return false;
}
